export const colorStyle = (color) => {
  if (color === 'purple') {
    return 'bg-gecko-purple';
  } else if (color === 'black') {
    return 'bg-stone-900';
  } else if (color === 'brown') {
    return 'bg-gecko-brown';
  } else if (color === 'green') {
    return 'bg-gecko-green';
  } else if (color === 'blue') {
    return 'bg-gecko-blue';
  } else if (color === 'white') {
    return `bg-white`;
  }
};

export const colorBgStyles = {
  lightBackgroundStyle: `color-background-content relative z-20 prose`,
  darkBackgroundStyle: `color-background-content relative z-20 *:text-white [&>.figure-left-aligned-out]:border-transparent [&_div>.figure-background]:bg-transparent [&_figcaption]:text-white [&_figure]:bg-transparent [&_p_a]:text-white [&_p_a:hover]:text-gecko-red`,
  caseStudyStyle: `[&_div.case-study]:bg-stone-200/[0.2] [&_div.case-study]:border-transparent [&_div.case-study]:border-l-white [&_div.case-study>*]:text-white [&_div.case-study_aside_*]:text-white [&_div.case-study_.footnote::before]:text-stone-200 [&_div.case-study_label[aria-describedby="footnote"]::after]:text-stone-200`,
  detailsStyle: `[&_details]:bg-stone-200/[0.2] [&_details]:border-transparent [&_details]:border-l-white [&_details>summary::marker]:text-white`,
  paraStyle: `[&_p:last-child]:mb-0 [&>p:first-of-type]:pt-12 [&_.slideshow-container-full_+_p]:pt-12 [&_p:last-child]:pb-12 [&_p:first-child]:mt-0 [&_p:first-child]:pt-12 [&_p:has(+_.color-background)]:mb-12 [&_strong]:text-white`,
  firstHeaderStyle: `[&_div.slideshow-container-full+h1]:mt-12 [&_h1:first-of-type]:pt-12 [&_h2:first-of-type]:mt-0 [&_h2:first-of-type]:pt-12`,
  relatedArticleStyle: `[&_div.related-article-container>a>*]:text-gray-400`,
};

// const paraBeforeSlideshow = `[&_p:has(+_.slideshow-container-full]:mt-12`;
